import {imagesMap} from "../../../DefaultMethods/DefaultMethods";

const DepositMethod = ({ methodPayment }) => {
    return (
        <div className="modal-payment-method d-flex just-content-space-between">
            <div className="d-flex flex-direction-column just-content-center">
                <p> Спосіб оплати </p>
                <span>{ methodPayment?.name }</span>
            </div>
            <img style={{maxHeight: "40px"}} src={imagesMap[methodPayment?.img]} alt={methodPayment?.name} />
        </div>
    );
};

export default DepositMethod;